/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import PropTypes from "prop-types";
import {AccessCodePSCLogEntry} from './AccessCodeSetupComponents/AccessCodePSCLogEntry';
import {TextInput} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import {getSessionStorage} from '../../../_helpers/localStorage.helper';
import {PERMISSIONS} from '../../../constants/APP_CONSTANTS';
import UserPermissionSingleton from '../../../_helpers/UserPermissionSingleton';

class AccessCodeSetup extends Component{
    static get propTypes() {
        return {
            isAccessCodeGenerateEnabled: PropTypes.bool.isRequired,
            collectionId: PropTypes.string,
            generateAccessCodeISBN: PropTypes.func.isRequired,
            sendAccessCodeISBNToPCS: PropTypes.func.isRequired,
            match: PropTypes.object.isRequired,
            pcsLogs: PropTypes.array.isRequired,
            sendAccessCodeToPCS:PropTypes.bool.isRequired,
            spwAccessCode: PropTypes.string,
            subscriptionLength: PropTypes.number,
            setSPWAccessCode: PropTypes.func.isRequired,
            setSubscriptionLength: PropTypes.func.isRequired,
            setComponent: PropTypes.func,
            sendAccessCodeToEtext: PropTypes.func.isRequired,
            guardDirtyIsActive: PropTypes.bool
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            isAccessCodeGenerateEnabled: false,
        };
        this.generateAccessCodeISBN = this.generateAccessCodeISBN.bind(this);
        this.sendAccessCodeISBNToPCS = this.sendAccessCodeISBNToPCS.bind(this);
        this.updateSPWAccessCode = this.updateSPWAccessCode.bind(this);
        this.updateSubscriptionLength = this.updateSubscriptionLength.bind(this);
        this.createAccessCardOffer = this.createAccessCardOffer.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        // You don't have to do this check first, but it can help prevent an unneeded render
        if (nextProps.isAccessCodeGenerateEnabled !== this.state.isAccessCodeGenerateEnabled) {
            this.setState({
                isAccessCodeGenerateEnabled: nextProps.isAccessCodeGenerateEnabled
            });
        }
    }

    componentDidMount() {
        if (typeof this.props.setComponent === 'function') {
            this.props.setComponent("AccessCodeSetup");
        }
        const collectionId = this.props.match.params.collId;
        //this.props.getAccessCodeInfo(this.props.match.params.collId);
    }

    componentWillUnmount() {
        this.props.guardDirtySetActive(false);
        this.props.getAccessCodeInfo(this.props.match.params.collId);
    }

    generateAccessCodeISBN(){
        const collectionId = this.props.collectionId;
        this.props.generateAccessCodeISBN(collectionId);
    }

    sendAccessCodeISBNToPCS(){
        const collectionId = this.props.collectionId;
        this.props.sendAccessCodeISBNToPCS(collectionId);
    }

    sendAccessCodeToEtext(){
        const collectionId = this.props.collectionId;
        this.props.sendAccessCodeToEtext(collectionId);
    }

    updateSPWAccessCode(event){
        const  re = /^[0-9\b]{1,10}$/;
        if (re.test(event.target.value)) {
            this.props.guardDirtySetActive(true);
            this.props.setSPWAccessCode(event.target.value);
        }else if (event.target.value === '') {
            this.props.guardDirtySetActive(true);
            this.props.setSPWAccessCode('');
        }
    }

    createAccessCardOffer(){
        const collectionId = this.props.collectionId;
        this.props.createOffer(collectionId);
    }

    updateSubscriptionLength(event){
        const re = /^[0-9\b]{1,3}$/;
        if (re.test(event.target.value)) {
            this.props.guardDirtySetActive(true);
            this.props.setSubscriptionLength(event.target.value);
        } else if (event.target.value === '') {
            this.props.guardDirtySetActive(true);
            this.props.setSubscriptionLength(0);
        }
    }

    render() {
        const pcsLogsMap = this.props.pcsLogs ? this.props.pcsLogs : [];
        const isLSAUser = getSessionStorage('isLSAUser');
        const isAccessCodeISBNButtonDisabled = UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_acess_code_ISBN_button);
        const isSendAccessCodetopdhDisabled = UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_send_access_code_to_pdh) || (this.props.activeCollection.geo.code === "CA");
        const isSendAccessCodetoEtextDisabled = UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_send_access_code_to_etext);
        return (
            <div className="access-code-setup-page">
                <div className="access-code-notes pe-row">
                    <p>
                        <strong>You may set-up access codes after initial eText Set-up</strong><br />
                        <strong>The eText will be available as Instant Purchase only until Access Codes are Sent to eText</strong>
                    </p>
                </div>
                <div className="access-code-generate pe-row">
                    <button onClick={this.generateAccessCodeISBN}
                        className='pe-btn btn_xlarge'
                        disabled={(!this.state.isAccessCodeGenerateEnabled) || isAccessCodeISBNButtonDisabled ? true : false} >Generate Access Code ISBN</button>
                </div>
                <div className="access-code-pcs pe-row">
                    <button onClick={this.sendAccessCodeISBNToPCS}
                        className='pe-btn__primary--btn_xlarge'
                        disabled={(!this.props.sendAccessCodeToPCS) || isSendAccessCodetopdhDisabled ? true : false}>
                        SEND ACCESS CODES TO PDH
                    </button>
                </div>
                <div className="access-code-spw pe-row">
                    <TextInput id="spwAccessCodeId"
                        labelText="SPW Access Code ID"
                        fancy={false}
                        changeHandler={this.updateSPWAccessCode}
                        inputState={UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_SPWAccessCode) ? "disabled" : "default"}
                        value={this.props.spwAccessCode}
                    />
                </div>
                <div className="access-code-subscription pe-row">
                    <div className="subscription-input">
                        <TextInput id="spwAccessCodeId"
                            labelText="Student subscription length"
                            fancy={false}
                            changeHandler={this.updateSubscriptionLength}
                            inputState={UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_etext_access_code_student_length) ? "disabled" : "default"}
                            value={this.props.subscriptionLength}
                        />
                        <div className="subscription-days">
                            <label className="pe-textLabelInput__label">days</label>
                        </div>
                    </div>
                </div>
                <div className="access-code-eText pe-row">
                </div>
                <div className="access-code-pcs pe-row">
                    <button onClick={this.createAccessCardOffer}
                        className='pe-btn__primary--btn_xlarge'
                        disabled={(this.props.isAccessCodeGenerateEnabled || this.props.guardDirtyIsActive || !this.props.subscriptionLength || !this.props.spwAccessCode || isLSAUser=='true' || isSendAccessCodetoEtextDisabled) ? true : false}>
                        SEND ACCESS CODES TO eText
                    </button>
                </div>
                <div className="access-code-eText pe-row">
                </div>
                <div className="access-code-setup-status">
                    <h2>Access Code Set-up Status</h2>
                    <div className="status-table">
                        {pcsLogsMap && pcsLogsMap.map((log, index) => (
                            log && log.isACXML && <AccessCodePSCLogEntry key={index} log={log} />
                        ))}

                    </div>
                </div>
            </div>
        );
    }
}

export default AccessCodeSetup;


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/AccessCodeSetup.js